import { i18n } from "./translator.js";
i18n.setGlobalData({
  year: new Date().getFullYear(),
});
import "../custom/CustomHeader.js";
import "../custom/CustomFooter.js";
import "../custom/Skeleton.js";
$("document").ready(function () {
  // const burgerBtn = document.getElementById("burgerBtn");
  // const mobileNav = document.getElementById("mobileNav");
  // burgerBtn.addEventListener("click", () => {
  //   burgerBtn.classList.toggle("open");
  //   mobileNav.classList.toggle("open");
  // });
});

export function createSkeletons(template, count = 2, container) {
  const references = [];
  for (let i = 0; i < count; i++) {
    const clone = template.content.cloneNode(true);
    const skeleton = clone.querySelector("custom-skeleton");

    skeleton.classList.add("page-placeholder"); //marked as temporary

    references.push(skeleton);
    container.appendChild(clone);
  }
  return references;
}

export function addSkeleton(templateNode, container) {
  const clone = templateNode.content.cloneNode(true);
  const newCard = clone.querySelector("custom-skeleton");
  container.appendChild(clone);
  //return [clone, newCard];
  return newCard;
}
export function removeExtraSkeletons(container) {
  const leftoverSkeletons = container.querySelectorAll(
    "custom-skeleton.page-placeholder",
  );
  leftoverSkeletons.forEach((skeleton) => {
    skeleton.remove();
  });
}

export function getAvailableSkeleton(key, container, template) {
  let existingCard = document.getElementById(key);
  if (existingCard) {
    return existingCard;
  }

  let availableSkeleton = container.querySelector(
    "custom-skeleton.page-placeholder",
  );

  if (availableSkeleton) {
    availableSkeleton.classList.remove("page-placeholder");

    return availableSkeleton;
  } else {
    return addSkeleton();
  }
}

export function displayStars(container, score) {
  //const container = document.getElementById("star-container");

  // 1. Get the numeric rating from data attribute and round it
  const rating = Math.round(
    parseFloat(score || container.getAttribute("data-rating")),
  );
  const maxStars = 5;

  // 2. Generate filled and empty star strings using .repeat()
  const filledStars = "★".repeat(rating);
  const emptyStars = "☆".repeat(maxStars - rating);

  // 3. Inject the complete star string into the element
  container.innerHTML = filledStars + emptyStars;
}

export function getStars(rating) {
  console.log("rating: ", rating);

  const ratingNum = Math.round(parseFloat(rating));
  const maxStars = 5;

  // 2. Generate filled and empty star strings using .repeat()
  const filledStars = "★".repeat(rating);
  const emptyStars = "☆".repeat(maxStars - rating);
  return filledStars + emptyStars;
}

export function getRadioLink(radioName) {
  if (radioName.includes("-")) {
    radioName = radioName.replace(/-/g, "--");
  }

  return "chat/" + radioName.replace(/\s+/g, "-");
}
